import React, {  } from 'react';
import { Form, Input } from 'antd';




const { TextArea } = Input;


export default function SamostoyatelnayaRegistratsiyaVikhodaIzChlenstvaVFederatsii(props) {

    return (
        <Form
            form={props.form}
            onFinish={props.submit}
            labelAlign={"left"}
            layout={"vertical"}
        >
            <Form.Item
                name={"prichinaTekst"}
                label={"Причина"}
                rules={[{ required: true, message: 'Укажите причину!' }]}
            >
                <TextArea rows={4} />
            </Form.Item>
        </Form>
    );
}
